import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Input, Select } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { Link } from '@ipc/ipc-core';
import locale from 'date-fns/locale/en-US';
import OperatorImpcSelectionContainer
  from '../../../../common/selection-criteria/operator-impc/container/OperatorImpcSelectionContainer';
import { postEdiRfidAuditCreateRequestActionCreator } from './redux/actions/EdiRfidAuditRequestCreateActions';
import {
  getLeftCheckedMailProcessingCenters,
  getRightCheckedMailProcessingCenters,
} from '../../../../common/user/redux/selectors/UserDataSelectors';
import {
  onLeftMailProcessingCenterChecked,
  onRightMailProcessingCenterChecked,
} from '../../../../common/selection-criteria/operator-impc/redux/actions/OperatorImpcActions';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

const leftTree = {
  title: 'Outbound Operator & IMPC',
  onlyAssetImpcs: true,
  useGlobalPresets: false,
};
const rightTree = {
  title: 'Inbound Operator & IMPC',
  onlyAssetImpcs: true,
  useGlobalPresets: false,
};
const schedulingTypes = [
  {
    label: 'IMMEDIATE',
    value: 'IMMEDIATE',
  },
  {
    label: 'SCHEDULED',
    value: 'SCHEDULED',
  },
];
const frequencyTypes = [
  {
    label: 'Monthly',
    value: 'MONTHLY',
  },
  {
    label: 'Weekly',
    value: 'WEEKLY',
  },
  {
    label: 'Daily',
    value: 'DAILY',
  },
];
const dailyOptions = [
  { label: '00:00', value: 0 },
  { label: '01:00', value: 1 },
  { label: '02:00', value: 2 },
  { label: '03:00', value: 3 },
  { label: '04:00', value: 4 },
  { label: '05:00', value: 5 },
  { label: '06:00', value: 6 },
  { label: '07:00', value: 7 },
  { label: '08:00', value: 8 },
  { label: '09:00', value: 9 },
  { label: '10:00', value: 10 },
  { label: '11:00', value: 11 },
  { label: '12:00', value: 12 },
  { label: '13:00', value: 13 },
  { label: '14:00', value: 14 },
  { label: '15:00', value: 15 },
  { label: '16:00', value: 16 },
  { label: '17:00', value: 17 },
  { label: '18:00', value: 18 },
  { label: '19:00', value: 19 },
  { label: '20:00', value: 20 },
  { label: '21:00', value: 21 },
  { label: '22:00', value: 22 },
  { label: '23:00', value: 23 },
];
const weeklyOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
];
const monthlyOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
  { label: 11, value: 11 },
  { label: 12, value: 12 },
  { label: 13, value: 13 },
  { label: 14, value: 14 },
  { label: 15, value: 15 },
  { label: 16, value: 16 },
  { label: 17, value: 17 },
  { label: 18, value: 18 },
  { label: 19, value: 19 },
  { label: 20, value: 20 },
  { label: 21, value: 21 },
  { label: 22, value: 22 },
  { label: 23, value: 23 },
  { label: 24, value: 24 },
  { label: 25, value: 25 },
  { label: 26, value: 26 },
  { label: 27, value: 27 },
  { label: 28, value: 28 },
  { label: 29, value: 29 },
  { label: 30, value: 30 },
  { label: 31, value: 31 },
];

class EdiRfidAuditRequestCreateContainer extends Component {
  constructor(props) {
    super(props);
    if (props.location.data !== undefined) {
      this.state = {
        auditName: props.location.data.original.auditFilename,
        selectedStartDate: props.location.data.original.startDate,
        selectedEndDate: props.location.data.original.stopDate,
        schedulingType: props.location.data.original.type !== 'IMMEDIATE' ? 'SCHEDULED' : 'IMMEDIATE',
        frequencyType: props.location.data.original.type !== 'IMMEDIATE' ? props.location.data.original.type : null,
        executionMoment: props.location.data.original.type !== 'IMMEDIATE' ? props.location.data.original.executionMoment : null,
        errorMessage: '',
        validDate: true,
      };
      this.props.onLeftMailProcessingCenterChecked(props.location.data.original.outboundImpcs);
      this.props.onRightMailProcessingCenterChecked(props.location.data.original.inboundImpcs);
    } else {
      this.state = {
        auditName: '',
        selectedStartDate: moment().format('YYYY-MM-DD'),
        selectedEndDate: moment().format('YYYY-MM-DD'),
        schedulingType: 'SCHEDULED',
        frequencyType: 'MONTHLY',
        executionMoment: '3',
        errorMessage: '',
        validDate: true,
      };
    }
  }

  getAuditName = (e) => {
    this.setState({
      auditName: e.target.value,
    });
  }

  onStartDateChange = (newDate) => {
    if (this.state.schedulingType === 'SCHEDULED') {
      if (moment(newDate).isBefore(moment().format('YYYY-MM-DD'))) {
        this.setState({
          errorMessage: 'Scheduled start date cannot be in the past',
        });
      } else if (newDate === null) {
        this.setState({
          errorMessage: 'Scheduled start date cannot be null.',
        });
      } else {
        this.setState({
          errorMessage: '',
        });
      }
    } else if (this.state.schedulingType === 'IMMEDIATE') {
      if (newDate === null) {
        this.setState({
          errorMessage: 'Reporting start date cannot be null.',
        });
      } else {
        this.setState({
          errorMessage: '',
        });
      }
    }
    this.setState({
      selectedStartDate: newDate,
    });
  }

  onReportingEndDateChange = (newDate) => {
    if (this.state.schedulingType === 'IMMEDIATE') {
      if (moment(newDate, 'YYYY-MM-DD').isAfter(moment())) {
        this.setState({
          errorMessage: 'Reporting end date cannot be future dated',
        });
      } else {
        this.setState({
          errorMessage: '',
        });
      }
    }
    this.setState({
      selectedEndDate: moment(newDate).format('YYYY-MM-DD'),
    });
  }

  onScheduledEndDateChange = (newDate) => {
    if (this.state.schedulingType === 'IMMEDIATE') {
      if (moment(newDate, 'YYYY-MM-DD').isAfter(moment())) {
        this.setState({
          errorMessage: 'Reporting end date cannot be future dated',
        });
      } else {
        this.setState({
          errorMessage: '',
        });
      }
    }
    if (moment(newDate, 'YYYY-MM-DD').isValid()) {
      this.setState({
        selectedEndDate: moment(newDate).format('YYYY-MM-DD'),
      });
    } else {
      this.setState({
        selectedEndDate: null,
      });
    }
  }

  onSchedulingTypesChange = (selectedOption) => {
    this.setState({
      schedulingType: selectedOption.value,
      selectedStartDate: moment().format('YYYY-MM-DD'),
      selectedEndDate: moment().format('YYYY-MM-DD'),
      errorMessage: '',
    });
  }

  onFrequencyTypesChange = (selectedOption) => {
    this.setState({
      frequencyType: selectedOption.value,
    });

    if (selectedOption.value === 'MONTHLY') {
      this.onOptionsChange({ label: 3, value: 3 });
    } else if (selectedOption.value === 'WEEKLY') {
      this.onOptionsChange({ label: 1, value: 1 });
    } else if (selectedOption.value === 'DAILY') {
      this.onOptionsChange({ label: '06:00', value: 6 });
    }
  }

  onOptionsChange = (selectedOption) => {
    this.setState({
      executionMoment: selectedOption.value,
    });
  }

  onInvalidDate = (message) => {
    this.setState({
      validDate: message === '',
    });
  }

  apply = () => {
    if (this.state.schedulingType === 'IMMEDIATE') {
      this.props.postEdiRfidAuditCreateRequestActionCreator(
        this.state.auditName,
        null,
        this.props.rightCheckedMailProcessingCenter,
        this.props.leftCheckedMailProcessingCenter,
        this.state.selectedEndDate,
        this.state.selectedStartDate,
        null,
        this.state.schedulingType,
        this.state.selectedEndDate,
        this.state.selectedStartDate,
      );
    } else if (this.state.schedulingType === 'SCHEDULED') {
      this.props.postEdiRfidAuditCreateRequestActionCreator(
        this.state.auditName,
        this.state.executionMoment,
        this.props.rightCheckedMailProcessingCenter,
        this.props.leftCheckedMailProcessingCenter,
        this.state.selectedEndDate,
        this.state.selectedStartDate,
        this.state.frequencyType,
        this.state.schedulingType,
        this.state.selectedEndDate,
        this.state.selectedStartDate,
      );
    }
  }

  render() {
    const {
      selectedStartDate,
      selectedEndDate,
      errorMessage,
    } = this.state;

    const isApplyDisabled = this.props.rightCheckedMailProcessingCenter.length === 0
      || this.props.leftCheckedMailProcessingCenter.length === 0
      || this.state.auditName === ''
      || errorMessage !== ''
      || !this.state.validDate
      || this.selectedStartDate === null;

    return (
      <div className="general-content-container">
        <h1 className="title-div">EDI-RFID AUDIT REQUEST CREATE</h1>
        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <div className="checkboxtree-div open">
                <OperatorImpcSelectionContainer
                  leftTree={leftTree}
                  rightTree={rightTree}
                  appContext={this.props.appContext}
                  switchEnabled
                />
                <table className="operator-impc-detail">
                  <tbody>
                    <tr>
                      <td className="selected-impc">
                        Audit Name
                      </td>
                      <td className="selected-impc">
                        <Input value={this.state.auditName} onChange={this.getAuditName} />
                      </td>
                    </tr>
                    <tr>
                      <td className="selected-impc">
                        Scheduling Type
                      </td>
                      <td className="selected-impc">
                        <Select
                          placeholder={this.state.schedulingType}
                          options={schedulingTypes}
                          onChange={this.onSchedulingTypesChange}
                        />
                      </td>
                    </tr>
                    {this.state.schedulingType === 'SCHEDULED' && (
                      <tr>
                        <td className="selected-impc">
                          Frequency
                        </td>
                        <td className="selected-impc">
                          <Select
                            placeholder={this.state.frequencyType}
                            options={frequencyTypes}
                            onChange={this.onFrequencyTypesChange}
                          />
                        </td>
                      </tr>
                    )}
                    {this.state.schedulingType === 'SCHEDULED' && this.state.frequencyType === 'MONTHLY' && (
                      <tr>
                        <td className="selected-impc">
                          Date Report is run in Month*
                        </td>
                        <td className="selected-impc">
                          <Select
                            placeholder="3"
                            options={monthlyOptions}
                            onChange={this.onOptionsChange}
                          />
                        </td>
                      </tr>
                    )}
                    {this.state.schedulingType === 'SCHEDULED' && this.state.frequencyType === 'WEEKLY' && (
                      <tr>
                        <td className="selected-impc">
                          Date Report is run in Week*
                        </td>
                        <td className="selected-impc">
                          <Select
                            placeholder="1"
                            options={weeklyOptions}
                            onChange={this.onOptionsChange}
                          />
                        </td>
                      </tr>
                    )}
                    {this.state.schedulingType === 'SCHEDULED' && this.state.frequencyType === 'DAILY' && (
                      <tr>
                        <td className="selected-impc">
                          Hour Report is run in Day*
                        </td>
                        <td className="selected-impc">
                          <Select
                            placeholder="06:00"
                            options={dailyOptions}
                            onChange={this.onOptionsChange}
                          />
                        </td>
                      </tr>
                    )}
                    {this.state.schedulingType === 'SCHEDULED' && (
                      <tr>
                        <td className="selected-impc">
                          Reporting Period From
                        </td>
                        {this.state.frequencyType === 'DAILY' && (
                          <td className="selected-impc">
                            Previous Day
                          </td>
                        )}
                        {this.state.frequencyType === 'WEEKLY' && (
                          <td className="selected-impc">
                            Previous 7 Days
                          </td>
                        )}
                        {this.state.frequencyType === 'MONTHLY' && (
                          <td className="selected-impc">
                            Previous Calendar month
                          </td>
                        )}
                      </tr>
                    )}
                    <tr>
                      {this.state.schedulingType === 'IMMEDIATE' && (
                        <td className="selected-impc">
                          Reporting Start Date
                        </td>
                      )}
                      {this.state.schedulingType === 'SCHEDULED' && (
                        <td className="selected-impc">
                          Scheduled Start Date
                        </td>
                      )}
                      <td className="selected-impc">
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                          <Grid container>
                            <KeyboardDatePicker
                              disableToolbar
                              autoOk
                              format="dd-MM-yyyy"
                              margin="normal"
                              id="date-picker-inline"
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              value={selectedStartDate}
                              onChange={this.onStartDateChange}
                              onError={this.onInvalidDate}
                            />
                          </Grid>
                        </MuiPickersUtilsProvider>
                      </td>
                    </tr>
                    {this.state.schedulingType === 'IMMEDIATE' && (
                      <tr>
                        <td className="selected-impc">
                          Reporting End Date
                        </td>
                        <td className="selected-impc">
                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                            <Grid container>
                              <KeyboardDatePicker
                                disableToolbar
                                autoOk
                                format="dd-MM-yyyy"
                                margin="normal"
                                id="date-picker-inline"
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                value={selectedEndDate}
                                onChange={this.onReportingEndDateChange}
                                minDate={selectedStartDate}
                                minDateMessage="Start date can not be after end date."
                                onError={this.onInvalidDate}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                        </td>
                        <td style={{ color: 'red' }}>{errorMessage}</td>
                      </tr>
                    )}
                    {this.state.schedulingType === 'SCHEDULED' && (
                      <tr>
                        <td className="selected-impc">
                          Scheduled Stop Date
                        </td>
                        <td className="selected-impc">
                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                            <Grid container>
                              <KeyboardDatePicker
                                disableToolbar
                                autoOk
                                format="dd-MM-yyyy"
                                margin="normal"
                                id="date-picker-inline"
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                value={selectedEndDate}
                                onChange={this.onScheduledEndDateChange}
                                minDate={selectedStartDate}
                                minDateMessage="Start date can not be after end date."
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                        </td>
                        <td style={{ color: 'red' }}>{errorMessage}</td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        <Link to={{ pathname: '/edi-rfid-audit', state: { tableId: 'EDI_RFID_AUDIT_REQUESTS_LIST_PAGE' } }}>
                          <Button className="primary-button">Cancel</Button>
                        </Link>
                      </td>
                      <td>
                        <Button
                          onClick={this.apply}
                          disabled={isApplyDisabled}
                          className={`primary-button-${isApplyDisabled}`}
                        >
                          {this.state.schedulingType === 'IMMEDIATE' ? 'Run' : 'Apply'}
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EdiRfidAuditRequestCreateContainer.propTypes = {
  appContext: PropTypes.objectOf(PropTypes.string),
  postEdiRfidAuditCreateRequestActionCreator: PropTypes.func,
  leftCheckedMailProcessingCenter: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenter: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.objectOf(PropTypes.shape),
  onLeftMailProcessingCenterChecked: PropTypes.func,
  onRightMailProcessingCenterChecked: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    leftCheckedMailProcessingCenter: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenter: getRightCheckedMailProcessingCenters(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postEdiRfidAuditCreateRequestActionCreator,
  onLeftMailProcessingCenterChecked,
  onRightMailProcessingCenterChecked,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EdiRfidAuditRequestCreateContainer);
